module.exports = __webpack_public_path__ + "img/c43.6782806c.gif";